/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
    constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cartElement = document.querySelector('ajax-cart');

        this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
        this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));

        this.giftInput = this.querySelector('[data-giftInput]');
        this.giftMsgTextarea = this.querySelector("[data-giftMsgTextarea]");
        this.giftMsgTextareaDiv = this.querySelector('[data-giftMsgTextareaDiv]');
        this.giftWrappedCheckbox = this.querySelector("[data-giftWrappedCheckbox]");
        if (this.giftWrappedCheckbox) this.giftWrappedCheckbox.addEventListener('change', this.toggleGiftMsgBox.bind(this));
    }

    /**
     * Product Form Submit event
     *
     * @param {evt} Event instance
     */
    onSubmitHandler(evt) {
        evt.preventDefault();
        const addItems = [];
        const addOnItems = [];
        const submitButton = this.querySelector('[type="submit"]');
        var getAttr = this.querySelector('form').getAttribute('is_gift_card');
        if (getAttr == "true") {
            if (document.querySelector('[data-dyanmicCheckout] [data-testid="sheet-open-button"]') != null) {
                document.querySelector('[data-dyanmicCheckout] [data-testid="sheet-open-button"]').click();
                return;
            }
        }
        const qtyInput = this.querySelector('[data-qty-input]');
        const pdpContainer = this.closest('.product-details-wrapper');

        if(this.giftMsgTextarea != null){
          if (this.giftMsgTextarea.value == '') {
            this.giftMsgTextarea.removeAttribute('name');
          } else {
            this.giftMsgTextarea.setAttribute('name', 'properties[Gift Message]');
          }
        }
        

        submitButton.setAttribute('disabled', true);
        submitButton.classList.add('loading');

        addItems.push(JSON.parse(serializeForm(this.form)))
        if (pdpContainer) {
            let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
            addOnItemsEle.forEach((addOn) => {
                if (addOn.disabled == false) {
                    let addOnParent = addOn.closest('addons-form');
                    let addOnJSON = {
                        id: addOnParent.querySelector('.variant--id').value,
                        quantity: addOnParent.querySelector('.product-quantity').value
                    }
                    addItems.push(addOnJSON);
                }
            });
        }
        addItems.forEach(item => {
            if (this.form.querySelector('[data-gift_random]') != null && item.properties['_gift_amount'] != undefined) {
                this.form.querySelector('[data-gift_random]').value = new Date().toLocaleDateString();
            }
        });
        const body = JSON.stringify({
            items: addItems
        });

        fetch(`${routes.cart_add_url}`, {...fetchConfig(), body })
            .then((response) => response.json())
            .then((parsedState) => {
                if (document.querySelector('#PopupModal-quickshop')) {
                    document.querySelector('#PopupModal-quickshop .close-quickshop').dispatchEvent(new Event('click'))
                }
                this.cartElement.getCartData('open_drawer');
                if (qtyInput) qtyInput.value = 1;
                if (this.giftInput) this.giftInput.value = 'No';
                if (this.giftMsgTextarea) this.giftMsgTextarea.value = '';
                if (this.giftMsgTextarea) this.giftMsgTextarea.setAttribute('disabled', 'disabled');
                if (this.giftMsgTextareaDiv) this.giftMsgTextareaDiv.classList.add('d-none');
                if (this.giftWrappedCheckbox) this.giftWrappedCheckbox.checked = false;
            })
            .catch((e) => {
                console.error(e);
            })
            .finally(() => {
                submitButton.classList.remove('loading');
                submitButton.removeAttribute('disabled');
            });
    }

    /**
     * Product Form Quantity Input update action
     *
     * @param {event} Event instance
     */
    manageQtyBtn(event) {
        event.preventDefault();
        let currentTarget = event.currentTarget;
        let action = currentTarget.dataset.for || 'increase';
        let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
        let currentQty = parseInt($qtyInput.value) || 1;
        let finalQty = 1;

        const maxQtyAttr = currentTarget.closest('[data-qty-container]').querySelector('[data-maxQty]')?.getAttribute('data-maxQty') || null;
        let maxQty = parseInt(maxQtyAttr, 10);
        if (isNaN(maxQty)) {
            maxQty = 0;
        }

        if (action == 'decrease' && currentQty <= 1) {
            return false;
        } else if (action == 'decrease') {
            finalQty = currentQty - 1;
        } else {
            finalQty = currentQty + 1;
        }

        if (Number.isFinite(maxQty) && maxQty > 0) {
            if (finalQty >= maxQty) {
                this.querySelector('.increase-qty').classList.add('disabled');
                finalQty = maxQty;
            } else {
                this.querySelector('.increase-qty').classList.remove('disabled');
            }
        } else {
            this.querySelector('.increase-qty').classList.remove('disabled');
        }

        $qtyInput.value = finalQty;
    }

    toggleGiftMsgBox(event) {
        this.giftMsgTextareaDiv.classList.toggle('d-none');
        if (event.currentTarget.checked) {
            this.giftInput.value = 'Yes';
            this.giftMsgTextarea.removeAttribute('disabled');
        } else {
            this.giftInput.value = 'No';
            this.giftMsgTextarea.setAttribute('disabled', 'disabled');
        }
    }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
    constructor() {
        super();
        this.form = this.closest('form') || this.closest('.form-element');
        this.formType = this.form.dataset.format;
        this.addBtn = this.form.querySelector('[name="add"]');
        this.variant_json = this.form.querySelector('[data-variantJSON]');
        this.variantPicker = this.dataset.type;
        this.specialOrderBadge = this.closest('product-form').querySelector('#special-order-badge');

        if (this.formType == 'product-page') this.onVariantChange('load');
        this.addEventListener('change', this.onVariantChange.bind(this));
    }

    onVariantChange(event) {
        this.setCurrentVariant();
        if (this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

        if (!this.currentVariant) {
            this.toggleAddButton('disable');
            // Variant name update
            let options = this.form.querySelectorAll('[data-optionindex]');
            options.forEach(option => {
                let lableID = 'option' + option.dataset.optionindex;
                const selectedValue = option.querySelector('input[type="radio"]:checked');
                const lable = option.querySelector('.selected-option');
                if (!lable || !lableID || !selectedValue) return;
                lable.innerHTML = selectedValue.value;
            });
            this.specialOrderBadge.innerHTML = '';
        } else {
            if (this.formType == 'grid') {
                const productGrid = this.closest('[data-product-grid]');
                this.renderProductInfo(this.currentVariant, productGrid);
                this._updateLinks(productGrid);
                const productWrap = this.closest('.product-form');
                if (this.formType != 'quickshop') {
                    Shopify.optionsMap = {};
                    this.defaultProductOptionSetup(productWrap);
                    this.checkOptionSelection(productWrap);
                }
            } else {
                if (event) {
                    const productWrap = this.closest('.product-form');
                    if (event == 'load') {
                        templateProductJS.prototype.manageVariantSlider(this.currentVariant);
                    } else if (event) {
                        let currentTarget = event.target;
                        let pdpContainer = currentTarget.closest('[data-product-container]');
                        let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
                        let targetName = currentTarget.getAttribute('name') || '';
                        targetName = targetName.toLowerCase();

                        if (pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)) {
                            if (quickShopModal) {
                                quickShop.prototype.manageVariantSlider(this.currentVariant);
                            } else {
                                templateProductJS.prototype.manageVariantSlider(this.currentVariant);
                            }
                        }
                    }
                    if (this.formType != 'quickshop') {
                        Shopify.optionsMap = {};
                        this.defaultProductOptionSetup(productWrap);
                        this.checkOptionSelection(productWrap);
                    }
                }

                const productPage = this.closest('[data-product-container]');
                this.renderProductInfo(this.currentVariant, productPage);
                // this.updateQty(this.currentVariant);
                window.currentVariantId = this.currentVariant.id;
                window.currentVariantTitle = this.currentVariant.public_title;
            }
            this.updateURLandID(this.currentVariant);
            this.toggleAddButton('enable');

            if (this.currentVariant.special_order_badge && Number(this.currentVariant.inventory_quantity) <= 0 && this.currentVariant.inventory_policy === 'continue') {
                this.specialOrderBadge.innerHTML = this.currentVariant.special_order_badge;
            } else {
                this.specialOrderBadge.innerHTML = '';
            }
        }
    }

    // setup product option global data.
    defaultProductOptionSetup(productData) {
        Shopify.arrayIncludes = function(e, t) {
            for (var n = 0; n < e.length; n++)
                if (e[n] == t)
                    return !0;
            return !1
        };

        Shopify.uniq = function(e) {
            for (var t = [], n = 0; n < e.length; n++)
                Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
            return t
        };

        var productId = `productVariants_${window.productJson.id}`;
        var productVariants = window[productId];
        var productOptions = JSON.parse(productData.getAttribute('data-product-options'));
        for (var i = 0; i < productVariants.length; i++) {
            var variant = productVariants[i];
            if (variant.available) {

                // Gathering values for the 1st drop-down.
                if (productOptions.length === 1) {
                    Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
                    Shopify.optionsMap['root'].push(variant.option1);
                    Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
                }

                // Gathering values for the 2nd drop-down.
                if (productOptions.length > 1) {
                    var key = variant.option1;
                    Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                    Shopify.optionsMap[key].push(variant.option2);
                    Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                }

                // Gathering values for the 3rd drop-down.
                if (productOptions.length === 3) {
                    var key = variant.option1 + ' / ' + variant.option2;
                    Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
                    Shopify.optionsMap[key].push(variant.option3);
                    Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
                }
            }
        }
    }

    // add disable class to input label
    addDisableClassToOptionLable(productData) {
        var optionData = productData.querySelectorAll('[data-format] .js.product-form__input');
        if (optionData.length > 0) {
            optionData.forEach((el, i) => {

                var optionElement = el.querySelectorAll('.list-unstyled li');
                if (optionElement.length > 0) {
                    optionElement.forEach((item, i) => {
                        item.querySelector('label').classList.add('is--disable');
                    })
                }
            })
        }
    }

    checkOptionSelection(productData) {
        this.addDisableClassToOptionLable(productData);
        var optionsCount = productData.querySelectorAll('[data-format] .js.product-form__input').length;

        if (optionsCount > 0 && Shopify.optionsMap !== undefined) {
            if (optionsCount === 1) {
                Shopify.optionsMap["root"].forEach((el, i) => {
                    productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                })
            } else if (optionsCount === 2) {
                var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
                var option_2 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;
                if (Shopify.optionsMap[option_1] != undefined) {
                    Shopify.optionsMap[option_1].forEach((el, i) => {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    })
                }

                for (var key in Shopify.optionsMap) {
                    if (Shopify.optionsMap[key].indexOf(option_2) != -1) {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${key}"]`).classList.remove('is--disable');
                    }
                }
            } else if (optionsCount === 3) {
                var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
                var option_2 = productData.querySelector('[data-format] .js.product-form__input:nth-child(2) .list-unstyled input:checked').value;
                var option_3 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;
                if (Shopify.optionsMap[option_1] != undefined) {
                    Shopify.optionsMap[option_1].forEach((el, i) => {
                        var option2 = Shopify.optionsMap[option_1][i];
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option2}"]`).classList.remove('is--disable');
                    })
                }

                var option2Data = `${option_1} / ${option_2}`;
                Shopify.optionsMap[option2Data].forEach((el, i) => {
                    var option3 = Shopify.optionsMap[option2Data][i];
                    productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option3}"]`).classList.remove('is--disable');
                })

                var customOption1 = [];
                var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:first-child .list-unstyled li');
                if (firstSwatchOptions.length > 0) {
                    firstSwatchOptions.forEach((optionEl, i) => {
                        customOption1.push(optionEl.querySelector('label').getAttribute('title'));
                    })
                }
                customOption1.forEach((el, i) => {
                    var customOptionName = `${el} / ${option_2}`;
                    if (Shopify.optionsMap[customOptionName] != undefined && Shopify.optionsMap[customOptionName].indexOf(option_3) != -1) {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    } else {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
                    }
                })

                var customOption2 = [];
                var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:nth-child(2) .list-unstyled li');
                if (firstSwatchOptions.length > 0) {
                    firstSwatchOptions.forEach((optionEl, i) => {
                        customOption2.push(optionEl.querySelector('label').getAttribute('title'));
                    })
                }
                customOption2.forEach((el, i) => {
                    var customOption2Name = `${option_1} / ${el}`;
                    if (Shopify.optionsMap[customOption2Name] != undefined && Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1) {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
                    } else {
                        productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
                    }
                })
            }
        }
    }

    updateQty(currentVariant) {
        var currentVariantId = currentVariant.id;
        var varJson = JSON.parse(document.querySelector('[data-variant-inventory]').textContent);
        var varQty = parseInt(varJson[currentVariantId]);
        var html = "";
        for (let index = 1; index <= varQty; index++) {
            html += `<option value="${index}">${index}</option>`;
        }
        document.querySelector('#quantity').innerHTML = html;
    }

    _updateLinks(productGrid) {
        if (!this.currentVariant || !productGrid) return;
        const variantURL = '?variant=' + this.currentVariant.id;
        const formLinks = productGrid.querySelectorAll('.product-link');
        formLinks.forEach(link => {
            let href = link.href.split('?')[0];
            link.href = href + variantURL;
        });
    }

    _getOptionsFromSelect() {
        let options = [];
        this.querySelectorAll('.variant_selector').forEach((selector) => {
            options.push(selector.value);
        });
        return options;
    }

    _getOptionsFromRadio() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
        const options = fieldsets.map((fieldset) => {
            return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
        });
        return options;
    }

    setCurrentVariant() {
        // get all current values from selectors
        this.currentVariant = false;
        let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

        let variantsArray = this._getVariantData();
        variantsArray.find((variant) => {
            // get true or false based on options value presented in variant
            // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
            let mappedValues = variant.options.map((option, index) => {
                return options[index] === option;
            });

            // assign variant details to this.currentVariant if all options are present
            if (!mappedValues.includes(false)) {
                this.currentVariant = variant;
                return;
            }
        });
    }

    updateURLandID(currentVariant) {
        if (!currentVariant) return;

        // update query string with latest variant ID
        if (this.formType == 'product-page') window.history.replaceState({}, '', `${this.dataset.url}?variant=${currentVariant.id}`);

        // update variant input with currentVariant Id
        const input = this.form.querySelector('input[name="id"]');
        input.value = currentVariant.id;
    }

    renderProductInfo(currentVariant, container) {
        if (!currentVariant || !container) return;

        // Price Update
        let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
        let compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
        let priceElement = container.querySelector('[data-currentPrice]');
        let comparePriceElement = container.querySelector('[data-comparePrice]');
        let selectedVarinatValueElement = this.querySelectorAll('[data-selected_value]');
        // let swatchesElement = this.querySelectorAll('.color-swatch [data-ImageSwatch]');
        selectedVarinatValueElement.forEach((element, index) => {
            element.innerHTML = `${currentVariant.options[index]}`
        })

        if (document.querySelector('[data-productMedia]') != null) {
            const mediaJSON = JSON.parse(document.querySelector('[data-productMedia]').innerHTML);
            window.productMedia = mediaJSON;
        }

        if(container.querySelector('[data-sku_value]')){
          let skuElement = container.querySelector('[data-sku_value]');
          skuElement.innerHTML = currentVariant.sku;
        }

        if(container.querySelector('[data-giftCardAmount]')){
          let skugiftCardAmount = container.querySelector('[data-giftCardAmount]');
          skugiftCardAmount.value = (currentVariant.price / 100.00);
        }

        if (priceElement) priceElement.innerHTML = price;
        if (comparePriceElement) {
            comparePriceElement.innerHTML = compare_price;
            if (currentVariant.compare_at_price <= 0) {
                comparePriceElement.style.display = 'none';
            } else {
                comparePriceElement.style.display = 'block';
            }
        }

        // Grid Image Update on variant selection
        if (this.formType == 'grid') {
            if (!currentVariant.featured_image) return;
            const featuredImage = container.querySelector('[data-feauredImage]');
            let updatedSrc = currentVariant.featured_image.src;
            if (updatedSrc) {
                featuredImage.src = updatedSrc;
                featuredImage.srcset = updatedSrc;
            }
        } else {
            if (!currentVariant.featured_image) return;
            let imageUrl = currentVariant.featured_image_url;
            let imageSlide = document.querySelector(`.product--media[data-media-url="${imageUrl}"]`);
            if (this.formType == 'quickshop') {
                imageSlide = document.querySelector(`.quickshop-slider .product--media[data-media-url="${imageUrl}"]`);
            }
            if (!imageSlide) return;
            let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
            if (quickShopSlider) quickShopSlider.slideTo(slideIndex, 0, true);
            else if (productSlider) productSlider.slideTo(slideIndex, 0, true);

            const mediaId = imageSlide.getAttribute('data-mediaid');
            if (!mediaId) return;
            const thumbnail = document.querySelector(`.product-thumb--image[data-mediaid="${mediaId}"]`);
            if (!thumbnail) return;
            const thumbnailSlide = thumbnail.closest('sl-carousel');
            if (!thumbnailSlide) return;
            const thumbIndex = Number(thumbnail.getAttribute('data-index'));
            if (!thumbIndex) return
            thumbnailSlide.querySelectorAll('.product-thumb--image').forEach(thumb => {
                thumb.classList.remove('swiper-slide-thumb-active');
            });
            thumbnailSlide.goToSlide(thumbIndex, 'auto');
            thumbnail.classList.add('swiper-slide-thumb-active');
        }

        // Variant name update
        let options = this.form.querySelectorAll('[data-optionindex]');
        options.forEach(option => {
            let lableID = 'option' + option.dataset.optionindex;
            const lable = option.querySelector('.selected-option');
            if (!lable || !lableID) return;
            lable.innerHTML = currentVariant[lableID];
        });
    }

    toggleAddButton(status) {
        if (!this.addBtn) return;

        if (status == 'disable') {
            this.addBtn.setAttribute('disabled', true);
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
        } else if (this.currentVariant && this.currentVariant.inventory_quantity <= 0 && this.currentVariant.inventory_policy === 'continue') {
            this.addBtn.removeAttribute('disabled');
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.preOrder;
        } else if (this.currentVariant && !this.currentVariant.available) {
            this.addBtn.setAttribute('disabled', true);
            if (this.addBtn.querySelector('.add-text'))
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
        } else {
            this.addBtn.removeAttribute('disabled');
            if (this.form.classList.contains('cart-upsell-form')) {
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
            } else {
                this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
            }
        };
    }

    _getVariantData() {
        this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
        return this.variantData;
    }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
    constructor() {
        super();

        this.form = this.closest('form') || this.querySelector('.form-element');
        this.formType = this.form.dataset.format;
    }
}
customElements.define('variant-radios', VariantRadios);

(() => {
    document.addEventListener("click", (event) => {
        // event.preventDefault();
        if (event.target.getAttribute("data-selector") === 'postal-code') {
            document.querySelector('[data-Postalnotfound]').classList.add('d-none')
            document.querySelector('[data-PostalWrongfound]').classList.add('d-none')
            let postalCode = document.querySelector('[data-postalCode]').value;
            if (postalCode === '') {
                document.querySelector('[data-Postalnotfound]').classList.remove('d-none')
            } else {
                let flag = false;
                window.zipcodes.George_Bush.George_Bush.forEach(code => {
                    if (code == postalCode) {
                        document.querySelector('[data-pickupAvailablility]').classList.remove('d-none')
                        flag = true
                    } else {
                        if (!flag) {
                            document.querySelector('[data-PostalWrongfound]').classList.remove('d-none')
                        }
                    }

                })
            }
        }

    });
})()